export const Paths = {
    AssetManagement: 'assets',
    Home: 'home',
    Login: 'login',
    Market: 'marketBuilding',
    Lease: 'tenantLeasePortal',
    Ratings: 'buildingScores',
    ScoreWeights: 'score-weights',
    Users: 'users'
};